'use strict';

module.exports = {
    LANG: 'pl-pl',
    SIGN: 'Zaloguj',
    REGISTER: 'ZAREJESTRUJ SIĘ',
    QUICK_ACCESS: 'Szybki dostęp dzięki',
    SIGN_JOIN: 'Zaloguj lub zarejestruj się!',
    NOT_MEMBER: 'Nie jesteś członkiem?',
    ALREADY_MEMBER: 'Jesteś już członkiem AliExpress/Alibaba?',
    SHOW_ALL: 'Pokaż wszystkie',
    HIDE: 'Ukryj'
};